/**
 * Converts a given date string to a formatted string representing the date and time in local time zone.
 * @param {string} time - The date string to convert (e.g., 'YYYY-MM-DDTHH:mm:ss.sssZ').
 * @returns {string} A string representing the date and time in the format 'YYYY-MM-DD HH:MM:SS'.
 */
// const getTimeStamp = (time) => {
//     if (!time) return '';
//     const date = new Date(time); // UTC date equivalent
//     const dateStr = date.toLocaleString(); // convert original UTC date object to the local time but in string format
//     const localDate = new Date(dateStr); // convert the locale string back to a Date object
//     const year = localDate.getFullYear();
//     const month = localDate.getMonth() + 1;
//     const day = localDate.getDate();
//     const hours = localDate.getHours();
//     const minutes = localDate.getMinutes();
//     const seconds = localDate.getSeconds();
//     return `${year}-${month.toString().padStart(2, '0')}-${day
//         .toString()
//         .padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes
//         .toString()
//         .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
// };

// export default getTimeStamp;

const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: userTimeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
});

const getTimeStamp = (time) => {
    if (!time) return '';
    const date = new Date(time);
    if (Number.isNaN(date.getTime())) return '';

    return formatter.format(date);
};

export default getTimeStamp;

const formatForDateTimeInput = (time) => {
    if (!time) return '';

    const date = new Date(time);
    if (Number.isNaN(date.getTime())) return '';

    const pad = (n) => String(n).padStart(2, '0');

    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
    )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export { formatForDateTimeInput };
